<template>
    <div class="apprentice-simple-card pws-sources">
        <div class="component-title">
            <h5 class="title">{{ $t('paper.sources') }}</h5>
        </div>

        <ul class="list-unstyled sources-list">
            <b-media
                class="pws-media"
                v-for="(source, index) in sources"
                tag="li"
                :key="`${index}-source.source`">
                <template #aside>
                    <b-img
                        :src="`/images/pws/brands/${source.image}`"
                        :alt="`${source.source} logo`"></b-img>
                </template>
                <h5 class="title">{{ source.title }}</h5>
                <p class="source">{{ source.source }}</p>
                <p class="description">
                    {{ source.description }}
                </p>
                <a
                    class="clickable"
                    :href="source.link"
                    target="_blank"></a>
            </b-media>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'design-2021-profile-paper-index-source-component',
    data() {
        return {
            sources: [
                {
                    title: this.$t('paper.source.delpher_title'),
                    source: 'Delpher',
                    image: 'delpher-logo.png',
                    description: this.$t('paper.source.delpher_description'),
                    link: 'https://www.delpher.nl/',
                },
                {
                    title: this.$t('paper.source.hbo_kennisbank_title'),
                    source: 'HBO Kennisbank',
                    image: 'logo-hbo-kennisbank.png',
                    description: this.$t('paper.source.hbo_kennisbank_description'),
                    link: 'https://www.hbo-kennisbank.nl/',
                },
                {
                    title: this.$t('paper.source.pixabay_title'),
                    source: 'Pixabay',
                    image: 'pixabay.png',
                    description: this.$t('paper.source.pixabay_description'),
                    link: 'https://www.pixabay.com/',
                },
                {
                    title: this.$t('paper.source.scribbr_title'),
                    source: 'Scribbr',
                    image: 'scribbr-logo.png',
                    description: this.$t('paper.source.scribbr_description'),
                    link: 'https://www.scribbr.nl/bronnengenerator/apa',
                },
                {
                    title: 'Amsterdamse Dataportaal',
                    source: 'Amsterdamse Dataportaal',
                    image: 'gemeente-amsterdam-logo.png',
                    description: this.$t('paper.source.amsterdamse_dataportaal_description'),
                    link: 'https://data.amsterdam.nl',
                },
                {
                    title: 'arXiv',
                    source: 'arXiv',
                    image: 'arxiv-logo.png',
                    description: this.$t('paper.source.arxiv_description'),
                    link: 'https://arxiv.org',
                },
                {
                    title: this.$t('paper.source.beeld_en_geluid_op_school_title'),
                    source: 'Beeld en Geluid op School',
                    image: 'beeld-en-geluid.png',
                    description: this.$t('paper.source.beeld_en_geluid_op_school_description'),
                    link: 'https://www.beeldengeluidopschool.nl',
                },
                {
                    title: 'DART-Europe E-theses Portal',
                    source: 'DART Europe',
                    image: 'dart-europe-portal.gif',
                    description: this.$t('paper.source.dart_europe_description'),
                    link: 'https://www.dart-europe.org/basic-search.php ',
                },
                {
                    title: 'Directory of Open Access Books',
                    source: 'DOAB',
                    image: 'doab-logo.png',
                    description: this.$t('paper.source.doab_description'),
                    link: 'https://www.doabooks.org',
                },
                {
                    title: 'Directory of Open Access Journals',
                    source: 'DOAJ',
                    image: 'doaj-logo.jpeg',
                    description: this.$t('paper.source.doaj_description'),
                    link: 'https://doaj.org',
                },
                {
                    title: 'Encyclopedia.com',
                    source: 'Encyclopedia.com',
                    image: 'encyclopedia.com-logo.jpg',
                    description: this.$t('paper.source.encyclopedia_com_description'),
                    link: 'https://www.encyclopedia.com',
                },
                {
                    title: 'Google Scholar',
                    source: 'Google Scholar',
                    image: 'google-scholar.png',
                    description: this.$t('paper.source.google_scholar_description'),
                    link: 'https://scholar.google.nl',
                },
                {
                    title: this.$t('paper.source.koninklijke_bibliotheek'),
                    source: this.$t('paper.source.koninklijke_bibliotheek'),
                    image: 'koninklijke-bibliotheek-logo.png',
                    description: this.$t('paper.source.koninklijke_bibliotheek_description'),
                    link: 'https://www.kb.nl',
                },
                {
                    title: this.$t('paper.source.nexisuni_title'),
                    source: 'nexisuni',
                    image: 'nexis-uni-logo.png',
                    description: this.$t('paper.source.nexisuni_description'),
                    link: 'https://www.nexisuni.com',
                },
                {
                    title: this.$t('paper.source.het_4e_gymnasium_mediatheek_title'),
                    source: this.$t('paper.source.het_4e_gymnasium_mediatheek_title'),
                    image: 'mediatheekcatalogus-logo.png',
                    description: this.$t('paper.source.het_4e_gymnasium_mediatheek_description'),
                    link: 'https://het4egymnasium.auralibrary.nl/auraicx.aspx',
                },
                {
                    title: 'Narcis',
                    source: 'Narcis',
                    image: 'narcis-logo.png',
                    description: this.$t('paper.source.narcis_description'),
                    link: 'https://www.narcis.nl/search/Language/nl',
                },
                {
                    title: 'OAPEN',
                    source: 'OAPEN',
                    image: 'oapen-logo.jpeg',
                    description: this.$t('paper.source.oapen_description'),
                    link: 'https://www.oapen.org/home',
                },
                {
                    title: 'OAIster',
                    source: 'OAIster',
                    image: 'oaister-logo.png',
                    description: this.$t('paper.source.oaister_description'),
                    link: 'https://oaister.worldcat.org',
                },
                {
                    title: 'OpenAIRE',
                    source: 'OpenAIRE',
                    image: 'openaire-logo.png',
                    description: this.$t('paper.source.openaire_description'),
                    link: 'https://explore.openaire.eu',
                },
                {
                    title: 'Topotijdreis',
                    source: this.$t('paper.source.topotijdreis_source'),
                    image: 'kadaster-logo.png',
                    description: this.$t('paper.source.topotijdreis_description'),
                    link: 'https://www.topotijdreis.nl',
                },
                {
                    title: 'Worldcat',
                    source: 'Worldcat',
                    image: 'worldcat-logo.png',
                    description: this.$t('paper.source.worldcat_description'),
                    link: 'https://www.worldcat.org',
                },
                {
                    title: 'isdatechtzo.nl',
                    source: 'isdatechtzo.nl',
                    image: 'isdatechtzo-logo.png',
                    description: this.$t('paper.source.isdatechtzo_description'),
                    link: 'https://isdatechtzo.nl',
                },
                {
                    title: this.$t('paper.source.hva_bibliotheek_title'),
                    source: this.$t('paper.source.hva_bibliotheek'),
                    image: 'hva-logo.png',
                    description: this.$t('paper.source.hva_bibliotheek_description'),
                    link: 'https://www.hva.nl/bibliotheek/ondersteuning/zoeken/videos-slim-zoeken/videos-slim-zoeken.html',
                },
                {
                    title: this.$t('paper.vrije_universiteit_libguide'),
                    source: 'Vrije Universiteit Amsterdam',
                    image: 'vrije-universiteit-logo.png',
                    description: this.$t('paper.vrije_universiteit_libguide_description'),
                    link: 'https://libguides.vu.nl/c.php?g=566702&p=3903179',
                },
                {
                    title: 'Documaken',
                    source: 'Documaken',
                    image: 'documaken-logo.png',
                    description: this.$t('paper.source.documaken_description'),
                    link: 'https://documaken.nl/',
                },
                {
                    title: this.$t('paper.source.litlab_handleiding_pws_title'),
                    source: 'Universiteit Utrecht',
                    image: 'universiteit-utrecht-logo.png',
                    description: this.$t('paper.source.litlab_handleiding_pws_description'),
                    link: 'https://litlab.nl/pws/',
                },
            ],
        };
    },

    mounted() {
        this.sources = this.sources.sort(() => Math.random() - 0.5);
    },
};
</script>

<style scoped lang="scss">
.pws-sources {
    .sources-list {
        height: 600px;
        overflow: auto;
    }
}

.pws-media {
    position: relative;
    transition: all 0.5s ease;
    padding: map-get($grid-gutter-spacing, 'twenty-one') map-get($grid-gutter-spacing, 'ten');
    border-bottom: 3px dotted $border-color;

    .media-aside {
        img {
            width: 115px;
            height: auto;
        }
    }

    .title,
    .source {
        margin-bottom: 0;
    }

    .source {
        font-weight: $font-weight-bold;
    }

    .description {
        color: $text-muted-color;
    }

    &:hover {
        background-color: $secondary-background-color;
        box-shadow:
            0 3px 21px 0 rgb(0 0 0 / 10%),
            0 1px 8px 0 rgb(0 0 0 / 5%);
    }
}

@media (min-width: map-get($grid-breakpoints, 'lg')) {
    .pws-sources {
        .sources-list {
            height: 620px;
            overflow: auto;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'xl')) {
    .pws-sources {
        .sources-list {
            height: 535px;
            overflow: auto;
        }
    }
}
</style>
